import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartOptions,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = ({ value }: any) => {
  const data = {
    labels: ["Value 1", "Value 2"],
    datasets: [
      {
        data: [
          Number(value?.totalPresentPercentage),
          Number(value?.totalAbsentPercentage),
        ],
        backgroundColor: ["#3BD4AF", "#F66868"],
        borderWidth: 4,
        hoverOffset: 4,
      },
    ],
  };

  const options: ChartOptions<"doughnut"> = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  return (
    <div style={{ position: "relative", width: "179px", height: "179px" }}>
      <Doughnut data={data} options={options} />
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "24px",
          fontWeight: "bold",
        }}
      >
        {value === null ? "0%" : `${Number(value?.totalPresentPercentage)}%`}
      </div>
    </div>
  );
};

export default DonutChart;
